import { ReactNode, useContext } from "react";

import ConfigContext from "context/ConfigContext";

import CitiesFAQs from "./CitiesFAQs";

type Props = {
  extraClasses: string;
  children: ReactNode;
};

const SectionWrapper = ({ extraClasses, children, ...others }: Props) => (
  <div className={`px-lg ${extraClasses || ""}`} {...others}>
    {children}
  </div>
);

function CitiesFAQsWithData() {
  const { FAQData } = useContext(ConfigContext);
  if (!FAQData?.data?.faqs) {
    return null;
  }
  return (
    <>
      {FAQData.data.faqs.length > 0 && (
        <SectionWrapper extraClasses="bg-green-20 py-xxl">
          <CitiesFAQs data={FAQData.data.faqs} />
        </SectionWrapper>
      )}
    </>
  );
}

export default CitiesFAQsWithData;
